export default class ClearPostFormInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-post-form-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-post-form-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs via Select2 API if available, otherwise native
                var $selects = $('#blog_service, #blog_sector, #content_type, #blog_author');
                if ($.fn.select2 && $selects.data('select2')) {
                    $selects.val('').trigger('change');
                } else {
                    $selects.val('');
                }

                // Submit the form
                document.getElementById('category').submit();

            }); 
        }
    }
};

new ClearPostFormInputs();
